import {Flex, Icon, Theme as ThemeWithoutType, Title} from 'exsportia-components'
import {FC, useEffect, useMemo, useState} from 'react'
import {useNavigate, useParams, useSearchParams} from 'react-router-dom'

import {GridLayout} from '../../layout/grid-layout/grid-layout'
import {ThemeType} from '../../theme/types'
import {Button} from '../../ui/components/button/button'
import {CHECKIN_URL} from '../../utils/environment'
import {useLocale} from '../../utils/i18n'
import {getPosPaymentInfoFromSession} from '../../utils/local-storage'
import {isNotNilAndNotEmpty} from '../../utils/logic'
import {useTimeout} from '../../utils/use-idle-timer'
import {extractDataFromQuery} from './payment-page'


export const PaymentFail: FC = () => {
  const {l} = useLocale()
  const Theme = ThemeWithoutType as ThemeType
  const params = useParams<{venueId: string}>()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const [isFromCheckIn, setIsFromCheckIn] = useState(false)
  const queryData = useMemo(() => extractDataFromQuery(searchParams), [searchParams])

  const handleGoToCheckInApp = () => {
    window.location.href = `${CHECKIN_URL}`
  }
  const handleClickGoToVenue = () => {
    if (isFromCheckIn) {
      handleGoToCheckInApp()
    } else {
      navigate(`/${params.venueId}`)
    }
  }

  const {goBackMessage} = useTimeout({
    delay: 10000,
    isDisabled: !isFromCheckIn,
    // Same reason as payment-success: on the kiosk an idle-reset timer is
    // restarted by every touch, so the return to check-in would never fire.
    resetOnActivity: false,
    callback: () => {
      handleGoToCheckInApp()
      return null
    },
  })


  useEffect(() => {
    const {entityId, withQR, posTerminalProcessId} = getPosPaymentInfoFromSession()
    if (entityId === queryData.entityId && !withQR && isNotNilAndNotEmpty(posTerminalProcessId)) {
      setIsFromCheckIn(true)
    }
    if (queryData.posTerminalProcessId && !queryData.withQR) {
      setIsFromCheckIn(true)
    }
  }, [])
  const handleClickGoToEntity = () => {
    let additionalParams = ''
    if (!queryData.entity || !queryData.entityId) {
      return
    }
    if (queryData.posTerminalProcessId) {
      additionalParams = `&posTerminalProcessId=${queryData.posTerminalProcessId}${queryData.withQR ? '&withQR=true' : ''}`
    }
    if (queryData.entity === 'booking-split') {
      navigate(`/${params.venueId}/bookings/${queryData.entityId}/pay`)
    } else {
      navigate(`/clear-view/${params.venueId}/payment?entityId=${queryData.entityId}&entity=${queryData.entity}${additionalParams}`)
    }
  }
  return (
    <GridLayout
      header={
        <Flex
          p='8px'
          justifyContent='center'
        >
          <Title
            settings={{textAlign: 'center'}}
            text={'Payment Fail'}
          />
        </Flex>
      }
    >
      <Flex
        alignItems='center'
        flexDirection='column'
        gap={Theme.spaces.multiplier2x}
      >
        <Icon
          settings={{
            width: '120px',
            height: '120px',
            iconWidth: '120px',
            iconHeight: '120px',
            color: Theme.colors.error,
          }}
          icon={'blocked'}
        />
        {queryData.entityId && queryData.entity && <Button onClick={handleClickGoToEntity}>{l('tryAgain')}</Button>}
        {params.venueId && (
          <Button
            type='secondary'
            onClick={handleClickGoToVenue}
          >
            {l('backToVenue')}
          </Button>
        )}
        {goBackMessage}
      </Flex>
    </GridLayout>
  )
}
